// extracted by mini-css-extract-plugin
export default {"container":"DataDisclaimer_container__b-8qg","icon":"DataDisclaimer_icon__H7Kc+","text":"DataDisclaimer_text__BJHmw"};